import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  Users,
  Clock
} from 'lucide-react';

const TeacherQuickActions = () => {
  const quickActions = [
    {
      title: 'View Batches',
      description: 'Manage students & classes',
      icon: Users,
      color: 'bg-teal-500 hover:bg-teal-600',
      link: '/teacher/batches'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          Quick Actions
        </h2>
        <div className="flex items-center text-sm text-gray-500">
          <Clock className="w-4 h-4 mr-1" />
          Updated now
        </div>
      </div>

      <div className="flex justify-center">
        {quickActions.map((action, index) => (
          <motion.div
            key={action.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 * index }}
            className="w-full max-w-sm"
          >
            <Link
              to={action.link}
              className={`block ${action.color} text-white rounded-lg p-6 transition-all duration-200 transform hover:scale-105 relative overflow-hidden group`}
            >
              {/* Background Pattern */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute -right-4 -top-4 w-16 h-16 rounded-full bg-white"></div>
                <div className="absolute -left-2 -bottom-2 w-8 h-8 rounded-full bg-white"></div>
              </div>

              {/* Content */}
              <div className="relative text-center">
                <div className="flex justify-center mb-4">
                  <action.icon className="w-8 h-8" />
                </div>
                <h3 className="font-semibold text-lg mb-2">{action.title}</h3>
                <p className="text-sm opacity-90">{action.description}</p>
              </div>

              {/* Hover Effect */}
              <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity"></div>
            </Link>
          </motion.div>
        ))}
      </div>

      {/* Today's Schedule Preview - Removed dummy data */}
      <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700">
        <h3 className="text-sm font-medium text-gray-900 dark:text-white mb-3">
          Today's Schedule
        </h3>
        <div className="text-center py-4">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            No classes scheduled for today
          </p>
        </div>
      </div>
    </div>
  );
};

export default TeacherQuickActions;